import React from 'react';
import { cn } from '@/lib/utils';

interface SectionEmptyStateProps {
  text: string;
  className?: string;
  dataTestId?: string;
}

export const SectionEmptyState = ({ text, className, dataTestId }: SectionEmptyStateProps) => (
  <div
    className={cn('w-full h-12 border-2 border-gray-200 rounded-lg px-5 flex items-center font-semibold', className)}
    style={{
      backgroundImage: `repeating-linear-gradient(
          -50deg,
          #F0F2F7,
          #F0F2F7 2px,
          transparent 2px,
          transparent 24px
        )`,
    }}
    data-testid={dataTestId}
  >
    {text}
  </div>
);
